import React, { useCallback, useEffect, useState } from "react";
import AddUserComponent from "./AddUserComponent";
import UserGrid from "./UserGrid";
import "../style/componentstyles.css";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import LoadingLoginScreen from "./LoadingLoginScreen";
import { getUserCompany, getUsersAPI } from "../services/UserService";

export default function Users() {
    const { currentUser, getCompanyValues } = useAuth();

    const [company, setCompany] = useState();
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [companyValues, setCompanyValues] = useState({});

    const fetchCompanyAndUsers = useCallback(async () => {

        try {
            setLoading(true);
            const userCompany = await getUserCompany(currentUser.uid);
            const companyUsers = await getUsersAPI(userCompany);
            const companyValues = await getCompanyValues(userCompany);

            setCompanyValues(companyValues);
            setCompany(userCompany);
            setUsers(companyUsers);
            setLoading(false);

        } catch (error) {

            console.error("Error when fetching company and users", error);

        }
    }, [currentUser.uid, getCompanyValues]);

    useEffect(() => {

        fetchCompanyAndUsers();
    }, [fetchCompanyAndUsers]);


    const maxUserLimitReached = users.length >= companyValues && companyValues.amountofAccounts;

    return (
        <Container>
            {loading ? (
                <LoadingLoginScreen />
            ) : (
                <Row>

                    <Col sm={8}>
                        <Card className={"card"}>
                            <UserGrid
                                users={users}
                                companyValues={companyValues}
                                loading={loading}
                            />
                        </Card>
                    </Col>
                    <Col sm={4}>
                        <Card className={"card"}>
                            <AddUserComponent
                                maxUsersLimitReached={maxUserLimitReached}
                                companyValues={companyValues}
                            />
                        </Card>
                    </Col>
                </Row>
            )}
        </Container>
    );
}
